import MapMutationContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MapMutationContent";
import NodeMutationBooleanContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NodeMutationBooleanContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import MapModel from "../model/MapModel";

export default class MapMutationCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {MapModel} mapModel 
     */
    constructor(dispatcher, mapModel) {
        super(dispatcher);

        this._mapModel = mapModel;
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {MapMutationContent} */
        const mapMutationContent = data.content;
        /** @type {NGTScenarioPlayer} */
        const contentPlayer = data.contentPlayer;

        const nodeId = mapMutationContent.getNodeID();
        const mutations = mapMutationContent.getMutations();
        mutations.forEach(mutation => this._doMutation(nodeId, mutation));

        contentPlayer.contentCompleted(mapMutationContent);
    }

    /**
     * @param {NodeMutationBooleanContent} mutation 
     */
    _doMutation(nodeId, mutation) {
        const mutationType = mutation.getMutationType();
        const mutationValue = mutation.getValue();
        switch (mutationType) {
            case NodeMutationBooleanContent.MUTATION_TYPES.VISIBLE:
                if (mutationValue) {
                    this._mapModel.makeCharacterAvailable(nodeId);
                } else {
                    this._mapModel.makeCharacterUnavailable(nodeId);
                }
                break;

            default:
                break;
        }
    }
}
